import { EthereumBitcoinDepositor } from "./bitcoin-depositor";
import { EthereumAcreBTC } from "./acrebtc";
import EthereumBitcoinRedeemer from "./bitcoin-redeemer";
import TbtcBridge from "./tbtc-bridge";
import TbtcVault from "./tbtc-vault";
import ERC20Token from "./erc20-token";
export * from "./bitcoin-depositor";
export * from "./address";
async function initializeTbtcContracts(runner, bitcoinDepositor) {
    const tbtcBridgeAddress = await bitcoinDepositor.getTbtcBridgeAddress();
    const tbtcVaultAddress = await bitcoinDepositor.getTbtcVaultAddress();
    const tbtcTokenAddress = await bitcoinDepositor.getTbtcTokenAddress();
    const tbtcBridge = new TbtcBridge(runner, tbtcBridgeAddress);
    const tbtcVault = new TbtcVault(runner, tbtcVaultAddress);
    const tbtcToken = new ERC20Token(runner, tbtcTokenAddress);
    return { tbtcBridge, tbtcVault, tbtcToken };
}
async function getEthereumContracts(runner, network) {
    const bitcoinDepositor = new EthereumBitcoinDepositor({ runner }, network);
    const acreBTC = new EthereumAcreBTC({ runner }, network);
    const bitcoinRedeemer = new EthereumBitcoinRedeemer({ runner }, network);
    const tbtcContracts = await initializeTbtcContracts(runner, bitcoinDepositor);
    bitcoinDepositor.setTbtcContracts(tbtcContracts);
    bitcoinRedeemer.setTbtcContracts(tbtcContracts);
    return { bitcoinDepositor, acreBTC, bitcoinRedeemer };
}
export { getEthereumContracts, EthereumBitcoinRedeemer };
//# sourceMappingURL=index.js.map